/**
 * Every path inside the Tenant Config workspace, in one place.
 *
 * The workspace is arranged as four top-level sections (Workspace, Access,
 * Settings, Automation), each with its own sub-tabs; the URLs mirror that
 * nesting, so a path prefix is enough to tell which section is active.
 */
export const TENANT_ROUTES = {
  // Workspace
  overview: '/tenant',
  subscription: '/tenant/subscription',

  // Access
  users: '/tenant/users',
  user: (id: string | number) => `/tenant/users/${id}`,
  permissionGroups: '/tenant/permission-groups',
  permissionGroup: (id: string | number) => `/tenant/permission-groups/${id}`,

  // Settings
  settings: '/tenant/settings',
  numbering: '/tenant/settings/numbering',
  numerationSchema: (id: string | number) => `/tenant/settings/numbering/${id}`,
  invoicing: '/tenant/settings/invoicing',
  reminders: '/tenant/settings/reminders',
  clientPortal: '/tenant/settings/client-portal',

  // Automation
  automation: '/tenant/automation',
  jobStatusActions: '/tenant/automation/job-status-actions',
  jobStatusAction: (id: string | number) => `/tenant/automation/job-status-actions/${id}`,
  jobFormRules: '/tenant/automation/job-form-rules',
  jobFormRule: (id: string | number) => `/tenant/automation/job-form-rules/${id}`,
} as const;
